<template>

        <div v-if="selectedItem" class="my-[60px]">
            <div class="grid grid-cols-1 md:grid-cols-10 gap-14 items-center">
                <div class="col-span-1 md:col-span-4">
                    <img
                        :src="selectedItem.image"
                        :alt="selectedItem.heading"
                        :style="{ height: lessonByTeachersImageHeight === 'auto' ? 'auto' : `${lessonByTeachersImageHeight}px` }"
                        class="hover:opacity-90 transition-opacity rounded-lg w-full"
                    />
                </div>
                <div class="col-span-1 md:col-span-6">
                    <p
                        class="text-[24px] font-[500]  leading-[normal] font-outfit mb-[20px]">
                        {{ selectedItem.heading }}
                    </p>
                    <p v-if="selectedItem.paragraph" class="text-[18px] font-[400] mb-[20px] leading-[normal] text-left font-outfit">
                       {{ selectedItem.paragraph }}
                    </p>
                    <div v-if="selectedItem.link" class="flex justify-start">

                        <button
                            @click="navigateTo"
                           class="outline outline-primary-500 text-primary-500  font-[500] rounded-xl w-auto px-[20px] py-2 hover:shadow duration-100  inline-flex items-center"
                        >
                           <span class="mr-2"> Go to lesson catalog </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="23" viewBox="0 0 34 23" fill="none">
<path d="M1.5 9.5459C0.671573 9.5459 0 10.2175 0 11.0459C0 11.8743 0.671573 12.5459 1.5 12.5459V11.0459V9.5459ZM33.5607 12.1066C34.1464 11.5208 34.1464 10.571 33.5607 9.98524L24.0147 0.439297C23.4289 -0.14649 22.4792 -0.14649 21.8934 0.439297C21.3076 1.02508 21.3076 1.97483 21.8934 2.56062L30.3787 11.0459L21.8934 19.5312C21.3076 20.117 21.3076 21.0667 21.8934 21.6525C22.4792 22.2383 23.4289 22.2383 24.0147 21.6525L33.5607 12.1066ZM1.5 11.0459V12.5459H32.5V11.0459V9.5459H1.5V11.0459Z" fill="#556FA4"/>
</svg>
                        </button>

                    </div>

                </div>


            </div>
        </div>

</template>
<script>



export default {
    components: {  },
    props: {
        selectedItem: {
            type: Object,
            default: null,
        },
        lessonByTeachersOpenNewTab:{
            type: Boolean,
            default: false
        },
        lessonByTeachersImageHeight:{
            type: [String, Number],
            default: 'auto'
        }
    },
    methods: {
        navigateTo() {
            const link = this.selectedItem?.link ;
            if (link) {
                window.open(link, this.lessonByTeachersOpenNewTab ? "_blank" : "_self");
            }
        }
    },
};
</script>

<style scoped>

</style>
